import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

// Send an SMS broadcast to the chosen audience (all / members / employees),
// optionally scoped to one branch. Delivery is queued server-side.
export async function sendsms(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/sendsms`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// History of past SMS sends, newest first, for the SMS List screen.
export async function smslist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/smslist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// SMS templates come from the shared notification_templates table. We only
// surface text-SMS templates (notification_type sms/both).
export async function smstemplates() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/gettemplates`, { params: { is_active: 1 }, headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Create a new SMS template. The caller supplies template_name + sms_body; the
// component fills in the code/type/trigger the backend requires.
export async function createsmstemplate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createtemplate`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
